"use client";
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import CiInteractiveMap, {ciInteractiveMapMarkers,} from "@/components/site-officiel/accueil/ci-interactive-map";
import { useNavigate } from "react-router-dom";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
      <CardTitle
        title={"Nos Régions"}
        backgroundImgSrc={"/images/card-title/Nos-Regions.jpg"}
      />

      {/* Breadcrumb */}
      <SectionPage sectionType="2xl">
        <div className={"flex justify-between items-center"}>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={"/"}>Nos Régions</BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </SectionPage>

      {/* Présentation */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"LE NORD : UN LIVRE D’HISTOIRE A CIEL OUVERT"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          Cela prend vie à travers huit magnifiques mosquées jalonnant les
          villes du Nord au Nord-Est telles que ; Sorobango, Tengréla, Kouto,
          Samatiguila, M’bengué, Kong (2 mosquées), Kaouara, . Elles possèdent
          toutes la même architecture typique datant de 1741 et désormais
          inscrites au patrimoine Mondial de l’Unesco.
          <br />
          <br />
          A travers cette découverte des mosquées de KONG, véritable prouesse
          architecturale, néo-soudanaise vous avez l’occasion de vous replonger
          dans cette ère d’expansion de l’Islam, de conquête, de croisade et de
          lutte anti coloniale avec l’épopée de L’Almamy SAMORY TOURE
          (1830-1900). Cette terre d’histoire a vu passer également d’autres
          grands hommes tels que le capitaine Louis-Gustave Binger et le
          Président Félix Houphouët Boigny.
          <br />
          <br />
          <span className="font-bold">« L’empreinte soudanise »</span>
        </AwesomeCard>
      </SectionPage>

      {/* galerie */}
      <SectionPage sectionType="2xl">
        <AwesomeCard className={"bg-white"} titleClassName={"text-bleu-marine"}>
          <div>
            <ImageGallery images={
              [
                  {
                    src: "/images/nos-regions/kong.jpg",
                    alt: "image1",
                    width: 1920,
                    height: 1080,
                  },
                  {
                    src: "/images/nos-regions/nord2.jpg",
                    alt: "image2",
                    width: 1920,
                    height: 1080,
                  },
                  {
                    src: "/images/nos-regions/nord3.jpg",
                    alt: "image3",
                    width: 1920,
                    height: 1080,
                  }
              ]
            } aspectRatio={"video"} gridClassName={"grid grid-cols-1 md:grid-cols-3 gap-4"} />
          </div>
        </AwesomeCard>
      </SectionPage>

      {/* Villes et Régions */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Villes et Régions"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          <div className={"flex justify-center w-full"}>
            <CiInteractiveMap
              strokeColor={"#ffffff"}
              markers={ciInteractiveMapMarkers(navigate)}
            />
          </div>
        </AwesomeCard>
      </SectionPage>
    </div>
  );
}
